import React from "react";
import DataTable from "react-data-table-component";
import LinearProgress from "@mui/material/LinearProgress";
import useActionTable from "./useActionTable.js";
import {targetedenergyList} from "variables/lists/action";

const PercentageOFEco = ({ oldValue, earnings }) => {
  let result = new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 3}).format((oldValue && earnings) ? ((earnings / oldValue) * 100) : 0);
  return <div>{result}</div>;
};

const RTExpertSavings = () => {
  const { gridState } = useActionTable();

  const columns = [
    {
      name: "Fluide",
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
     // cell: (row) => targetedenergyList.find((x) => x.id == row.energy)?.name || ""
    },
    {
      name: "Economies (MWh ou m3)",
      selector: (row) => row.earnings,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => (
          new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format(row.earnings)
      ),
    },
    {
      name: "Economies (%)",
      selector: (row) => row.savingspercent,
      sortable: true,
      cell: (row) => (
        <div>
          <PercentageOFEco oldValue={row.value} earnings={row.earnings} />
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader={true}
        //title="Simulation"
        subHeader
        noDataComponent="Aucune simulation trouvée"
        columns={columns}
        persistTableHead
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        {...gridState}
      />
    </>
  );
};

export default RTExpertSavings;
